import apiClient from "./api";

export async function actProvider(data) {
    try {
      const response = await apiClient.post("/eomws/actprovider", data); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: "No response received",
          details: error.request,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: "Request setup error",
          details: error.message,
        };
      }
    }
  }

  export async function deleteRelationsForProvider(data) {
    try {
      const response = await apiClient.post("/eomws/deleterelationsforprovider", data); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: "No response received",
          details: error.request,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: "Request setup error",
          details: error.message,
        };
      }
    }
  }

export async function postProvider(data) {
  try {
    const response = await apiClient.post("/eomws/postprovider", data); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return {
        success: false,
        message: "No response received",
        details: error.request,
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        success: false,
        message: "Request setup error",
        details: error.message,
      };
    }
  }
}

export async function getCountries() {
  try {
    const response = await apiClient.get("/eomws/getcountries"); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return {
        success: false,
        message: "No response received",
        details: error.request,
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        success: false,
        message: "Request setup error",
        details: error.message,
      };
    }
  }
}

export async function getSuppliers() {
  try {
    const response = await apiClient.get("/eomws/getproviders"); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return {
        success: false,
        message: "No response received",
        details: error.request,
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        success: false,
        message: "Request setup error",
        details: error.message,
      };
    }
  }
}
